import React from "react";
import { navigate } from "gatsby";
import { ImagePass } from "../../Image/ImagePass";

import "./icon-grid.scss";

export const IconGrid = (props) => {
  const { id, sectionTitle, sectionContent, grid } = props;

  const { backgroundColor, gridCellType, items } = grid;

  return (
    <div
      className={`icon-grid${
        backgroundColor === "#FFFFFF" || backgroundColor === "#F4F4F4"
          ? " light"
          : " dark"
      }`}
      style={{ backgroundColor }}
    >
      <div className="wrap">
        <div className="intro">
          {sectionTitle && sectionTitle.length > 0 && <h2>{sectionTitle}</h2>}
          {sectionContent && sectionContent.length > 0 && (
            <div dangerouslySetInnerHTML={{ __html: sectionContent }} />
          )}
        </div>
        {items.length > 0 && (
          <div className={`items ${gridCellType}`}>
            {Object.keys(items).length > 0 &&
              items?.map((item, idx) => {
                return (
                  <div
                    className={`item${item.isItemOutlined ? " outlined" : ""}${
                      item.isItemLink ? " link" : ""
                    }${
                      item.backgroundImage
                        ? " has-background"
                        : " no-background"
                    }`}
                    key={`${id}-${idx}`}
                    onClick={
                      item.isItemLink ? () => navigate(item.link) : () => null
                    }
                  >
                    {item.backgroundImage && (
                      <ImagePass
                        src={item.backgroundImage}
                        alt={item.backgroundImage.title}
                        position="relative"
                        className={`image`}
                      />
                    )}
                    <div className="content">
                      <div className="icon-container">
                        <ImagePass
                          src={item.icon}
                          className="icon"
                          position="relative"
                          lazy={false}
                        />
                      </div>
                      <h3>{item.title}</h3>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};
